// extracted by mini-css-extract-plugin
module.exports = {"name-event-cell-size":"activationEventList_name-event-cell-size__yd9b9"};